import React from "react";
import { Play, ArrowRight, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategicVision() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="60200" id="lexcellence-en-communication-b2b" ref={sectionRef} className="dark bg-background text-foreground relative w-full overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--primary)_0%,_transparent_25%)] opacity-10" />
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-[linear-gradient(to_top,_var(--background)_0%,_transparent_100%)]" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="lg:col-span-7 flex flex-col gap-8">
            <div className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              {}
              <Badge variant="outline" className="mb-6 border-primary/30 text-primary bg-primary/5 backdrop-blur-sm px-4 py-1.5 text-xs font-mono uppercase tracking-widest">
                Expertise Stratégique
              </Badge>
              
              <h1 className="text-4xl md:text-5xl lg:text-7xl font-serif font-bold leading-[1.1] tracking-tighter mb-6">
                <span className="block text-foreground">L’Excellence au service de</span>
                {}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-primary-300 to-primary">
                  votre Vision B2B
                </span>
              </h1>
              
              <p className="text-lg max-w-2xl leading-relaxed border-l-2 border-primary/30 pl-6 font-sans !text-[hsl(0,0%,100%)] md:text-xl">
                Positionnez votre organisation comme un acteur de référence avec une approche méthodologique rigoureuse. 
                Nous transformons vos ambitions en succès tangibles grâce à une expertise locale et des standards internationaux.
              </p>
            </div>

            <div className={`flex flex-wrap gap-4 pt-4 transition-all duration-1000 delay-200 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Link to="/ContactPage">
                {}
                <Button size="lg" className="h-14 px-8 text-base font-semibold bg-gradient-to-r from-primary to-primary-600 hover:from-primary/90 hover:to-primary-600/90 text-primary-foreground border-0 shadow-[0_0_20px_rgba(212,28,61,0.2)] transition-all hover:scale-105 rounded-sm">
                  Lancer un Projet
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
              
              <Link to="/ExpertisePage">
                <Button variant="outline" size="lg" className="h-14 px-8 text-base border-primary/20 hover:bg-primary/10 hover:text-primary hover:border-primary/50 transition-all rounded-sm font-medium">
                  Découvrir nos Expertises
                </Button>
              </Link>
            </div>

            {}
            <div className={`grid grid-cols-2 md:grid-cols-3 gap-6 pt-8 border-t border-border/20 transition-all duration-1000 delay-400 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              {["Conseil Stratégique", "Événementiel Corporate", "Identité de Marque"].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-3 text-sm font-medium text-muted-foreground font-sans">
                  {}
                  <CircleCheck className="h-5 w-5 text-primary shrink-0" />
                  <span className="!text-[hsl(0,0%,100%)]">Conseil Stratégique</span>
                </div>)}
            </div>
          </div>

          {}
          <div className={`lg:col-span-5 relative transition-all duration-1000 delay-300 ease-out transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative w-full aspect-[4/5] md:aspect-square lg:aspect-[4/5]">
              
              {}
              <div className="absolute -top-10 -right-10 w-2/3 h-2/3 bg-primary/20 rounded-full blur-3xl" />
              <div className="absolute -bottom-10 -left-10 w-2/3 h-2/3 bg-primary/10 rounded-full blur-3xl" />

              {}
              <div className="relative w-full h-full bg-card border border-border/30 shadow-2xl overflow-hidden group" style={{
              clipPath: "polygon(0% 0%, 100% 0%, 100% 25%, 45% 25%, 45% 45%, 85% 45%, 85% 70%, 45% 70%, 45% 100%, 0% 100%)"
            }}>
                {}
                <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1573891/img/strategic_vision_burkina_b2b.png)] transition-transform duration-700 group-hover:scale-105">
                  <div className="absolute inset-0 bg-background/40 group-hover:bg-background/20 transition-colors duration-500" />
                </div>

                {}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="h-16 w-16 rounded-full bg-primary/80 backdrop-blur-md flex items-center justify-center shadow-lg cursor-pointer hover:scale-110 transition-transform">
                    <Play className="h-6 w-6 text-primary-foreground fill-current ml-1" />
                  </div>
                </div>
              </div>

              {}
              <div className="absolute top-[20%] -right-4 md:-right-8 animate-pulse duration-[4000ms]">
                <div className="bg-card/80 backdrop-blur-xl border border-primary/30 p-4 rounded-sm shadow-xl flex items-center gap-3 max-w-[200px]">
                  <div className="h-10 w-10 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
                    <CircleCheck className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <p className="text-[10px] font-mono uppercase tracking-widest !text-[hsl(0,0%,100%)]">Agence</p>
                    <p className="text-sm font-bold text-foreground font-serif">Impact & Prestige</p>
                  </div>
                </div>
              </div>

              {}
              <div className="absolute bottom-[10%] -left-4 md:-left-8 w-24 h-24 border-2 border-primary/20 rounded-sm -z-10 rotate-12" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}